export const USER_AUTHED = "USER_AUTHED";
export const USER_LOGOUT = "USER_LOGOUT";

export const SET_RECAPTCHA_VERIFIER = "SET_RECAPTCHA_VERIFIER";
export const SET_CONFIRMATION_RESULT = "SET_CONFIRMATION_RESULT";

export const CANVASSER_SUCCESS = "CANVASSER_SUCCESS";

export const SET_APP_VERSION = "SET_APP_VERSION";